const StoreCategory = `
    name,           category_title,         true,       no_map_default;
    parent_id,      parent_category;
    time,           time_code_setting;
    is_active,      is_active;
    is_hidden,      is_hidden;
`;

export default StoreCategory;
